import { render, staticRenderFns } from "./storesTransfer.vue?vue&type=template&id=940ce90a"
import script from "./storesTransfer.vue?vue&type=script&lang=js"
export * from "./storesTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports